export default {
  prices: {
    // Homogeneous comparator (R-27…R-29, §90 phase 4A)
    hTitle: "Homogeneous comparison",
    hMembers: "{n} presentations",
    hLowest: "lowest price",
    hLevel_presentation: "Equivalent presentation",
    hLevel_unit: "Price per unit",
    hLevel_product: "Average per product",
    hLevelHint_presentation: "Presentations in the same homogeneous group: same active ingredient, strength, form, route and pack size. The cleanest comparison.",
    hLevelHint_unit: "Same molecule, strength and form with different pack sizes, normalised to price per unit. Assumes packs are equivalent.",
    hLevelHint_product: "Average price per unit for each brand. Useful for a portfolio view, not for specific pricing decisions.",
    hColPack: "Pack",
    hColPerUnit: "Retail / unit",
    hColVsOwn: "Δ vs own",
    hColVsLowest: "Δ vs lowest",
    hColBrand: "Brand",
    hColPresentations: "Presentations",
    hColAvgPerUnit: "Avg retail / unit",
    hColRange: "Range",
    hAtLowest: "at lowest price",
    hExcludedTitle: "{n} not compared because they cannot be normalised:",
    hReason_no_units: "pack not countable",
    hReason_no_price: "no price",
    hScopeNote: "Pharmacy channel only: retail price incl. VAT from the billing Nomenclátor and ex-factory price from the Ministry's monthly homogeneous-group listings. Real hospital prices are not public.",
    hUpdated: "data as of {date}",
    hOnlyAh: "(homogeneous comparison)",
    hError: "Could not load the homogeneous comparison",
    title: "Price Comparison",
    subtitle: "Compare only what is comparable: the presentations of one homogeneous group (agrupación homogénea: same active ingredient, strength, form and pack), today and month by month since 2015.",
    errorProducts: "Could not load your portfolio. Check your connection.",
    errorComparison: "Could not load the price history. Check your connection.",
    retry: "Retry",
    loadingPortfolio: "Loading portfolio…",
    productLabel: "Your product",
    noPriceData: "· no homogeneous group",
    loadingComparison: "Loading comparison…",
    filtersTitle: "Or find a group",
    filterAtc: "ATC",
    filterAtcPh: "e.g. C09DA",
    filterPa: "Molecule",
    filterPaPh: "e.g. olmesartan",
    filterProduct: "Product",
    filterProductPh: "e.g. Olmetec",
    filterCn: "Presentation (CN)",
    filterCnPh: "e.g. 674888",
    filterSearch: "Search",
    filterClear: "Clear",
    ahLabel: "Homogeneous group",
    ahOption: "{code} · {name} · {n} pres.",
    ahOwn: "yours: {n}",
    ahNone: "No group matches those filters.",
    ahTruncated: "More than 200: narrow the filters.",
    metricPvp: "Retail price incl. VAT",
    metricPvl: "Ex-factory price",
    metricHint: "The ex-factory price comes from the monthly homogeneous-group listings; the billing Nomenclátor only publishes the retail price.",
    periodLabel: "Period",
    period_1: "1 year",
    period_3: "3 years",
    period_5: "5 years",
    period_all: "Since 2015",
    historyTitle: "Price history · group {code}",
    lowestLine: "Group's official lowest price (precio menor)",
    noSeriesData: "No prices to show in this period. Tick presentations in the table below.",
    noAhForProduct: "This product is not in any homogeneous group (brand without generics or hospital channel): only its own history is shown.",
    presentationsLabel: "Presentations in the group",
    toggleHint: "Tick or untick to show them in the chart",
    omittedProducts: " · {n} more presentations not shown",
    colProduct: "Product",
    colLaboratory: "Laboratory",
    colLatest: "Latest price",
    colDate: "Month",
    colDiff: "Δ vs your product",
    colMonths: "Months",
    noData: "no data",
    otherPack: "other pack",
    otherPackHint: "The price per unit of a pack different from yours mostly reflects pack size: large packs are cheaper per unit, yours included. It is not a price advantage of the competitor.",
    tracked: "your competitor",
    trackedHint: "It is in your Competitors list",
    ownTag: "yours",
    leftGroup: "no longer in the group",
    noCompetitors: "No other presentations with prices in this group.",
    tableFooter: "Δ: difference of the latest price versus your product (green = cheaper than yours). A homogeneous group gathers presentations with the same active ingredient, strength, form, route and pack size.",
  },
};
